import { SearchSelectOptionProps } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

export const useCreateOptions = (list: SearchSelectOptionProps[]) => {
	const { t } = useTranslation();
	const options = list.map(
		({ value, label }: { value: string; label: string }) => {
			return {
				value,
				label: t(`lists.${label}`),
			};
		}
	);

	return options;
};
